import { Asset } from 'contentful'

import { formatExternalUrl } from '../url'
import { LinkData, LinkObjectFields, Pages } from './types'

export function mapFileLink(file: Asset<'WITHOUT_UNRESOLVABLE_LINKS'>): LinkData
export function mapFileLink(file: null | undefined): undefined
export function mapFileLink(file: Asset<'WITHOUT_UNRESOLVABLE_LINKS'> | null | undefined): LinkData | undefined {
  if (!file) return

  const {
    file: { url },
    title,
  } = file.fields
  return {
    title: title,
    href: formatExternalUrl(url),
  }
}

export function mapInternalLink(pageReference: Pages): LinkData {
  const { slug, title } = pageReference.fields || {}
  const href = slug === 'home' ? '' : slug
  return {
    title,
    href: `/${href}`,
  }
}

export function mapCombinedLink(link: LinkObjectFields): LinkData {
  const { linkTitle: title, pageReference, assetReference, externalLink, openLinkInNewTab } = link || {}

  if (pageReference) {
    return {
      ...mapInternalLink(pageReference),
      openLinkInNewTab,
      title,
    }
  }

  if (assetReference) {
    return {
      title,
      href: mapFileLink(assetReference).href ?? '',
      openLinkInNewTab,
    }
  }

  if (externalLink) {
    return {
      title,
      href: externalLink ?? '',
      openLinkInNewTab,
    }
  }

  return {
    title,
    href: '',
    openLinkInNewTab,
  }
}
